// extracted by mini-css-extract-plugin
export default {"section":"WelcomeBanner_section__ppOyo","title":"WelcomeBanner_title__Ljw+R","appEntry":"WelcomeBanner_appEntry__ypFil","appGrid":"WelcomeBanner_appGrid__vlav0"};